import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box, Typography, Divider, Paper} from '@mui/material';
import SeatLayoutWithAvailablityOptions from 'components/SeatLayoutWithFilters';
import { useParams } from 'react-router-dom';
import Modal from 'components/Modal';
import AddBooking from 'pages/bookings/Add';
import { AppContext } from 'core/context/';
import { useNavigate } from "react-router-dom";

const SeatAvailability = () => {
  const { libraryId } = useParams();
  const [bookingDetails, setBookingDetails] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const {libraries} = useContext(AppContext);

  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
    },
    [setOpenModal, navigate],
  );

  useEffect(() => {
    if(bookingDetails){
      setOpenModal(true);
    }else{
      setOpenModal(false);
    }
  }, [bookingDetails]);
   
  const onBookingAdded = useCallback(() => {
      navigate("/overview");
      setOpenModal(false);
  },[setOpenModal],);

  const bookSeatsHandler = useCallback((seatIds=[]) => {
    const [library] = libraries.filter(lib=> lib?.libraryId === libraryId);
    setBookingDetails({libraryId, seatIds, seatCount: seatIds?.length, library})
  },[libraryId]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom sx={{mb: 1}}>
        Seat Availability
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <SeatLayoutWithAvailablityOptions allowBooking={true} showBookingDetails={true} bookSeatsHandler={bookSeatsHandler}/>
      </Box>
      <Modal maxWidth={"md"}  open={openModal} onModalClose={onModalClose} title={bookingDetails ? 'Booking Details' : 'Add Booking'}>
        <AddBooking bookingDetails={bookingDetails} onBookingAdded={onBookingAdded} saveBtnText="Book" />
      </Modal>
    </Paper>
  );
}
 
export default SeatAvailability;
